// extracted by mini-css-extract-plugin
export default {"resetButton":"oZmXnEe","ontologyContentContainer":"tW9SUAk","editorContainer":"x_CyjeW","editorContainerViewMode":"xFSUf1w","activityBarWrapper":"JHz544i"};